import { useCallback, useEffect, useRef, useState } from "react";

import StudentCalendar from "../../components/SPanel/StudentCalendar";
import { openPopup } from "../../components/Common/popupUIStore";
// lecțiile și examenele elevului — din /api/calendar (view=personal), ca în calendarul nou
import { loadPersonalCalendarEvents } from "../../utils/personalCalendarEvents";

const SPCALENDAR_POLL_INTERVAL_MS = 45_000;
const SPCALENDAR_RESYNC_COOLDOWN_MS = 8_000;

function SPCalendar() {
   const [events, setEvents] = useState([]);
   const lastSyncAtRef = useRef(0);
   const pollTimerRef = useRef(0);

   const syncEvents = useCallback(async () => {
      try {
         setEvents(await loadPersonalCalendarEvents());
         lastSyncAtRef.current = Date.now();
      } catch (_) {}
   }, []);

   useEffect(() => {
      syncEvents();
   }, [syncEvents]);

   useEffect(() => {
      if (pollTimerRef.current) return;
      pollTimerRef.current = window.setInterval(() => {
         if (typeof document !== "undefined" && document.hidden) return;
         syncEvents();
      }, SPCALENDAR_POLL_INTERVAL_MS);
      return () => {
         if (pollTimerRef.current) {
            window.clearInterval(pollTimerRef.current);
            pollTimerRef.current = 0;
         }
      };
   }, [syncEvents]);

   useEffect(() => {
      const handleVisible = () => {
         if (typeof document !== "undefined" && document.hidden) return;
         if (Date.now() - lastSyncAtRef.current < SPCALENDAR_RESYNC_COOLDOWN_MS) return;
         syncEvents();
      };
      window.addEventListener("focus", handleVisible);
      document.addEventListener("visibilitychange", handleVisible);
      return () => {
         window.removeEventListener("focus", handleVisible);
         document.removeEventListener("visibilitychange", handleVisible);
      };
   }, [syncEvents]);

   const handleEventClick = useCallback((event) => {
      openPopup("eventInfo", { event });
   }, []);

   return (
      <main className="main">
         <section className="calendar page">
            <StudentCalendar
               events={events}
               onSelectEvent={handleEventClick}
            />
         </section>
      </main>
   );
}

export default SPCalendar;
